import styled from 'styled-components';
import { Box } from '@drone-js/core';

export const LeanScrollbarBox = styled(Box)`
    &::-webkit-scrollbar-track {
        background-color: #f9f9fa;
    }

    &::-webkit-scrollbar {
        background-color: #f9f9fa;
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #90949c;
        border-radius: 6px;
    }
`;
